var crTrackerQueue = (function() {

	return {
		track: function(data) {
			if (data) {
				if (Array.isArray(data)) {
					for (var i = 0; i < data.length; i++) {
						// console.log(data[i].category, data[i].action, data[i].label);
						_gaq.push(['_trackEvent', data[i].category, data[i].action, data[i].label]);
					}
				} else {
					// console.log(data.category, data.action, data.label);
					_gaq.push(['_trackEvent', data.category, data.action, data.label]);
				}
			}
		}
	
	};
})();
